exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Player_player__zS77t .Player_progress_bar__2PIUg {\n  width: 160px; }\n\n.Player_player__zS77t .Player_speed__2cNCr {\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  white-space: nowrap; }\n  .Player_player__zS77t .Player_speed__2cNCr:hover {\n    background-color: rgba(0, 0, 0, 0.2); }\n  .Player_player__zS77t .Player_speed__2cNCr .Player_range__SYBRm {\n    position: relative;\n    height: 16px;\n    width: 60px;\n    margin-left: 8px; }\n    .Player_player__zS77t .Player_speed__2cNCr .Player_range__SYBRm .Player_range_label_container__2r9cE {\n      display: none; }\n    .Player_player__zS77t .Player_speed__2cNCr .Player_range__SYBRm .Player_range_track__zOnWE {\n      top: 50%;\n      height: 6px;\n      margin-top: -3px;\n      background-color: #505050;\n      cursor: pointer;\n      display: block;\n      position: relative; }\n    .Player_player__zS77t .Player_speed__2cNCr .Player_range__SYBRm .Player_range_slider__1CSri {\n      top: 0;\n      width: 6px;\n      height: 12px;\n      margin-left: -3px;\n      margin-top: -3px;\n      -webkit-appearance: none;\n         -moz-appearance: none;\n              appearance: none;\n      background-color: #bbbbbb;\n      cursor: pointer;\n      display: block;\n      position: absolute; }\n", ""]);

// Exports
exports.locals = {
	"themeDark": "#242424",
	"themeNormal": "#393939",
	"themeLight": "#505050",
	"colorFont": "#bbbbbb",
	"colorShadow": "rgba(0, 0, 0, 0.2)",
	"colorOverlay": "rgba(255, 255, 255, 0.1)",
	"colorAlert": "#f3bd58",
	"colorSelected": "#2962ff",
	"colorPatched": "#c51162",
	"colorHighlight": "#29d",
	"colorActive": "#00e676",
	"lineHeight": "32px",
	"fontSizeNormal": "12px",
	"fontSizeLarge": "14px",
	"player": "Player_player__zS77t",
	"progress_bar": "Player_progress_bar__2PIUg",
	"speed": "Player_speed__2cNCr",
	"range": "Player_range__SYBRm",
	"range_label_container": "Player_range_label_container__2r9cE",
	"range_track": "Player_range_track__zOnWE",
	"range_slider": "Player_range_slider__1CSri"
};